export default function truncateText(message, characterLimit = 72, ellipsisText = '') {
  let truncateMessage = '';
  if (message && message.length > characterLimit) {
    truncateMessage = message.substr(0, characterLimit - ellipsisText.length) + ellipsisText;
  } else {
    truncateMessage = message;
  }
  return truncateMessage;
}
